import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDispatcherKPI from './ReportDispatcherKPI'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportDispatcherKPI} />
    </Switch>
)

export default Components
